import React from "react";
import loading from "./loading.gif";

export default () => {
    return (
        <div className="text-center">
            <h5>Loading <img src={loading} alt="loading" /></h5>
        </div>
    )
}